import React from "react";
import { useSelector } from "react-redux";
import { Button } from "rhombus-react";
import { useFlag } from '@innovid/feature-flags-react';

import { PreviewCreative } from "utils/Preview";
import { FEATURE_FLAGS } from 'featureFlag/featureFlag';

export default function PreviewVersionsButton({ disabled }) {
	const creative = useSelector(state => state.creativeDetails);
	const forceNewPreview = useFlag(FEATURE_FLAGS.NEW_PREVIEW_LINKS);

	const link = PreviewCreative.allVersions(creative, forceNewPreview).url;

	return (
		<a href={link} target="_blank">
			<Button
				key="preview"
				icon="preview"
				style="block"
				disabled={disabled}>Preview Versions
			</Button>
		</a>
	);
}
